module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"QuoteBlock":{"quoteImageAltText":"Uvozovky"}}}')
  delete Component.options._Ctor
}
